var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('CounterUsers'),_c('Checklist'),_c('Statistic'),_c('Infographics'),_c('Together'),_c('Footer'),_c('Thanks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }